import VideoUIRoleAndDescription from "./VideoUIRoleAndDescription";
import { MeetingDetails } from "@platform/features/video/types/video.types";

type Props = {
  meetingDetails: MeetingDetails;
};

export function VideoUIRoleAndDescriptionContainer({ meetingDetails }: Props) {
  const participantRole = meetingDetails.user_participation?.role?.name;

  const participantRoleDescription =
    meetingDetails.user_participation?.role?.description;

  if (!participantRole) {
    return null;
  }

  return (
    <VideoUIRoleAndDescription
      participantRole={participantRole}
      participantRoleDescription={participantRoleDescription}
    />
  );
}

export default VideoUIRoleAndDescriptionContainer;
